import React from "react";
import { MinimalPostCard } from "@/domains/PostCreator/cards/MinimalPostCard";
import type { GridItem } from "./types/grid.types";

interface ClientGridSlotProps {
  item: GridItem;
  onClick?: () => void;
}

export const ClientGridSlot: React.FC<ClientGridSlotProps> = ({
  item,
  onClick,
}) => {
  if (!item.post) {
    return <div className="w-full h-full bg-gray-100 rounded-xl" />;
  }

  return (
    <div
      className="w-full h-full cursor-pointer relative overflow-hidden"
      onClick={onClick}
    >
      <div className="pointer-events-none w-full h-full">
        <MinimalPostCard post={item.post} />
      </div>
    </div>
  );
};
